module.exports = __webpack_public_path__ + "img/MEDIA028.ff89cc3c.jpg";